import { render, staticRenderFns } from "./comOnlineShop.vue?vue&type=template&id=592dfb20&scoped=true"
import script from "./comOnlineShop.vue?vue&type=script&lang=js"
export * from "./comOnlineShop.vue?vue&type=script&lang=js"
import style0 from "./comOnlineShop.vue?vue&type=style&index=0&id=592dfb20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592dfb20",
  null
  
)

export default component.exports